module.exports = __webpack_public_path__ + "img/icon-lock.0f5357e3.svg";